import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAQklEQVR42n2NOQoAIRAE/f/bFnEVc4/YUTBzBlqNBAMbqqOCUnhP1P5aGzoR+Ldgs3AekvIlFML4NHijDSTEI7wSE/u1e/B2u8bjAAAAAElFTkSuQmCC"};
